import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'

export enum TrackingStatusEnum {
  created = 'created',
  transit = 'transit',
  delivered = 'delivered',
  failure = 'failure',
  returned_to_sender = 'returned_to_sender',
}

export interface TrackingStatusModelItem {
  icon: IconDefinition
  translationId: { [key: string]: string }
}

export interface TrackingStatusModel {
  [key: string]: TrackingStatusModelItem
}
